// English translations
export default {
  welcome: 'Welcome',
  tapToUnmute: 'Tap to unmute',
  likeHint: 'Like if you enjoyed',
  previousEpisode: 'Previous',
  nextEpisode: 'Next',
};

